import { Typography } from 'design-system/src/components/Typography/Typography';
import { DesktopContainer, MobileContainer } from './styles';
import Button, { ButtonProps, ButtonVariant } from 'design-system/src/components/Button/Button';
import styled from 'styled-components';

export const ResponsiveTitle = ({
  text,
  desktopTextAlign,
}: {
  text: string;
  desktopTextAlign?: 'left' | 'center' | 'right';
}) => (
  <>
    <DesktopContainer
      alignment={desktopTextAlign === 'left' ? 'flex-start' : desktopTextAlign === 'right' ? 'flex-end' : undefined}
    >
      <Typography styledAs="h4" marginBottom={24}>
        {text}
      </Typography>
    </DesktopContainer>
    <MobileContainer>
      <Typography styledAs="h5" marginBottom={24}>
        {text}
      </Typography>
    </MobileContainer>
  </>
);

export const ResponsiveButton = ({
  desktopText,
  mobileText,
  variant,
  onClick,
  ...rest
}: {
  desktopText: string;
  mobileText: string;
  variant: ButtonVariant;
  onClick: () => void;
} & ButtonProps) => {
  const commonProps = {
    variant,
    textStyledAs: 'bodySmallDMSans' as const,
    textWeight: 700,
    onClick,
    ...rest,
  };
  return (
    <>
      <DesktopContainer>
        <Button {...commonProps}>{desktopText}</Button>
      </DesktopContainer>
      <MobileContainer>
        <Button {...commonProps}>{mobileText}</Button>
      </MobileContainer>
    </>
  );
};

const FullWidthLabel = styled.label`
  width: 100%;
`;

export const ResponsiveCheckboxLabel = ({ children, htmlFor }: { children: React.ReactNode; htmlFor: string }) => (
  <>
    <DesktopContainer>
      <FullWidthLabel htmlFor={htmlFor}>
        <Typography>{children}</Typography>
      </FullWidthLabel>
    </DesktopContainer>
    <MobileContainer>
      <FullWidthLabel htmlFor={htmlFor}>
        <Typography styledAs="bodyExtraExtraSmallDMSans">{children}</Typography>
      </FullWidthLabel>
    </MobileContainer>
  </>
);
